/**
 * Local Supabase port configuration
 *
 * AUTO-GENERATED by scripts/supabase-ports.ts — do not edit manually.
 * Re-generated on every `bun run setup` or `bun run db:start`.
 */

export const LOCAL_SUPABASE_PORTS = {
  api: 54970,
  db: 54971,
  shadowDb: 54972,
  studio: 54973,
  inbucket: 54974,
  pooler: 54975,
  analytics: 54976,
  analyticsVector: 54977,
};

export const LOCAL_SUPABASE_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.api}`;
export const LOCAL_SUPABASE_STUDIO_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.studio}/project/default/editor`;
export const LOCAL_INBUCKET_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.inbucket}`;
